export default __webpack_public_path__ + "static/media/arrow-up-left.016bb4e6.svg";